import React from 'react';
import PropTypes from 'prop-types';
import MediaAttachment from './MediaAttachment';

export function normalizeUploadMediaAttachments({ media = null, mediaAttachments = [] } = {}) {
  const uploads = [];
  const seen = new Set();
  const addUpload = (entry) => {
    if (entry?.provider !== 'firebase_upload' || !entry?.uploadId) return;
    if (seen.has(entry.uploadId)) return;
    seen.add(entry.uploadId);
    uploads.push(entry);
  };

  addUpload(media);
  if (Array.isArray(mediaAttachments)) {
    mediaAttachments.forEach(addUpload);
  }
  return uploads;
}

export default function MediaAttachmentGrid({
  media,
  mediaAttachments = [],
  className = '',
  itemClassName = '',
  compact = false,
}) {
  const uploads = normalizeUploadMediaAttachments({ media, mediaAttachments });
  if (uploads.length === 0) return null;

  return (
    <div className={['media-attachment-grid', uploads.length === 1 ? 'media-attachment-grid--single' : '', className].filter(Boolean).join(' ')}>
      {uploads.map((entry) => (
        <MediaAttachment
          key={entry.uploadId}
          media={entry}
          className={['media-attachment-grid__item', itemClassName].filter(Boolean).join(' ')}
          compact={compact}
        />
      ))}
    </div>
  );
}

const mediaShape = PropTypes.shape({
  provider: PropTypes.string,
  uploadId: PropTypes.string,
  mediaType: PropTypes.string,
  storagePath: PropTypes.string,
  thumbnailPath: PropTypes.string,
  fileName: PropTypes.string,
});

MediaAttachmentGrid.propTypes = {
  media: mediaShape,
  mediaAttachments: PropTypes.arrayOf(mediaShape),
  className: PropTypes.string,
  itemClassName: PropTypes.string,
  compact: PropTypes.bool,
};
